import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ILead } from "../../../models/Lead";
import LeadNotes from "../LeadInformation/LeadNotes";
import VehicleNotes from "../LeadInformation/VehicleNotes";
import StatusTabs, { StatusTabItem } from "../../shared/Tabs/StatusTabs";
import useNotes from "../../../data/useNotes";
import NotesOutput from "../../shared/Notes/NotesOutput";
import { ResourceType } from "../../../models/Note";

export default function LeadNotesTab({ lead }: { lead: ILead }) {
  const { t } = useTranslation("leads");
  const { useNotesByResource } = useNotes();
  const { data } = useNotesByResource(lead.id);

  const callNotes = useMemo(() => {
    return (data?.data ?? []).filter((note) => note.resourceType === ResourceType.Call);
  }, [data]);

  const tabs = useMemo<StatusTabItem[]>(() => {
    return [
      {
        key: "office-notes",
        title: t("Office Notes"),
        status: lead.officeNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="officeNotes" title={t("Office Notes")} />,
      },
      {
        key: "driver-notes",
        title: t("Driver Notes"),
        status: lead.driverNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="driverNotes" title={t("Driver Notes")} />,   
      },
      {
        key: "yard-notes",
        title: t("Yard Notes"),
        status: lead.yardNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="yardNotes" title={t("Yard Notes")} />,   
      },
      {
        key: "vehicle-notes",
        title: t("Vehicle Notes"),
        status: lead.vehicle?.notes ? "complete" : "incomplete",
        children: <VehicleNotes vehicle={lead.vehicle!} />,   
      },
      {
        key: "call-notes",
        title: t("Call Notes"),
        status: callNotes.length > 0 ? "complete" : "incomplete",
        children: (
          <div className="p-4">
            <NotesOutput
              resourceId={lead.id}
              resourceType={ResourceType.Call}
              shouldScroll={false}
              notes={callNotes}
              refetchQuery={["notes", lead.id]}
            />
          </div>
        ),
      },
    ];
  }, [callNotes, lead, t]);

  return <StatusTabs tabs={tabs} defaultTabKey="office-notes" />;
}
